import React from 'react'
import useStyles from './styles'
import { Typography, Grid } from '@material-ui/core'

const Footer = () => {
  const classes = useStyles()

  return (
    <Grid container justifyContent="center" alignItems="center" className={classes.root}>
      <Typography variant="caption">Copyright &copy; 2021 - Gammovies.</Typography>
    </Grid>
  )
}

export default Footer
